import React from 'react';
import { Col, Icon, Row } from 'straightline-ui';
import { formatMoney, roundNumberToLabel } from 'straightline-utils/accounting';
import { isLTL } from 'straightline-utils/constants';

export default function ShipmentBanner({ shipment }) {
  return (
    <Row className="justify-content-between mb-n2">
      <Col xs="auto" className="mb-2">
        <h1 className="text-success mb-0" style={{ fontSize: 40 }}>
          {formatMoney(shipment.rate.price.shipper_price, { precision: 0 })}
        </h1>
      </Col>
      <Col xs="auto" className="text-right mb-2">
        <div className="text-secondary">
          {isLTL(shipment) ? 'LTL' : shipment.truck.label}
          <Icon type="dot" className="text-muted mx-1" />
          {roundNumberToLabel(shipment.load_weight)} lbs
        </div>
        <div className="text-secondary">
          {shipment.travel.miles} mi
          <Icon type="dot" className="text-muted mx-1" />
          {formatMoney(
            (
              shipment.rate.price.shipper_price / (shipment.travel.miles || 1)
            ).toFixed(1)
          )}
          /mi
        </div>
      </Col>
    </Row>
  );
}
